export default __webpack_public_path__ + "static/media/I can show you how to.79b81874.mp4";